import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';
import ProductImage from '../image/ProductImage';
import './_CarrouselFull.scss';

const CarrouselFull = ({
  advanceImage, backImage, currentImage, pos, setFull,
}) => (
  <>
    <div className='carrousel-close'>
      <Icon
        className='icon'
        size='large'
        name='window close'
        onClick={() => setFull(false)}
      />
    </div>
    <p>{`${pos + 1}/4`}</p>
    <ProductImage
      advanceImage={advanceImage}
      backImage={backImage}
      currentImage={currentImage}
      imageStyle='full-img'
    />
  </>
);

CarrouselFull.propTypes = {
  advanceImage: PropTypes.func,
  backImage: PropTypes.func,
  currentImage: PropTypes.string,
  pos: PropTypes.number,
  setFull: PropTypes.func,
};

export default CarrouselFull;
